import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/index'
Vue.use(Router)



var router =  new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/index',
      name: 'Indexs',
      component: Index
    }
  ],
})

router.afterEach((to, from) => {
  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  }

  if (window._czc) {
    window._czc.push(['_trackPageview', '/#' + to.fullPath])
    console.log('window._czc',window._czc)
  }
  /* 告诉增加一个PV */
  // try {
  //   // 只统计生产模式
  //   if (process.client && process.env.NODE_ENV === 'production') {
  //     window._hmt = window._hmt || []
  //     window._hmt.push(['_trackPageview', to.fullPath])
  //   } else {
  //   }
  // } catch (e) {}
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js